import type { MarketingDraft } from './marketingDraft';

const MAX = 5000;

interface Props {
  draft: MarketingDraft;
  onChange: (patch: Partial<MarketingDraft>) => void;
}

export function ProfileSectionDescription({ draft, onChange }: Props) {
  return (
    <section className="rounded-lg border border-border bg-card p-4 md:p-6" data-testid="marketing-description-card">
      <h2 className="text-base font-semibold text-foreground">Description</h2>
      <p className="mb-3 text-xs text-muted-foreground">
        Shown at the top of your listing under &ldquo;About this rental&rdquo;.
      </p>
      <label htmlFor="marketing-description" className="mb-1 block text-sm font-medium text-foreground">
        What makes this unit a good place to live?
      </label>
      <textarea
        id="marketing-description"
        value={draft.description}
        onChange={(e) => onChange({ description: e.target.value })}
        maxLength={MAX}
        rows={6}
        placeholder="Describe this property to prospective tenants..."
        data-testid="profile-description-input"
        className="box-border w-full resize-y rounded-md border border-input bg-background px-3 py-2.5 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      />
      <div className="mt-1 flex justify-between gap-3 text-xs text-muted-foreground">
        <span>Plain text. Line breaks are kept.</span>
        <span>
          {draft.description.length.toLocaleString('en-US')} / {MAX.toLocaleString('en-US')}
        </span>
      </div>
    </section>
  );
}
